import { FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function PhoneNumberValidator(control: FormControl): ValidationErrors | null {
    let regex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    if (control.value) {
        let inputValue = null;
        if (control.value instanceof String) {
            inputValue = control.value.trim();
        } else {
            inputValue = control.value;
        }
        if (!regex.test(inputValue)) {
            console.log("Number validator fail");
            return { "invalidPhoneNumber": true };
        }
    }
    return null;
}